'use client';

import { c as _c } from "react/compiler-runtime";
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useFormatter, useTranslations } from 'next-intl';
function WorldDates() {
  const $ = _c(17);
  const t = useTranslations();
  const format = useFormatter();
  const {
    roomData
  } = useCheckEnterRoomContext();
  let t0;
  if ($[0] !== format) {
    t0 = value => value ? format.dateTime(new Date(value), {
      month: "short",
      day: "numeric",
      year: "numeric"
    }) : null;
    $[0] = format;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const formatDate = t0;
  const t1 = roomData?.first_public_date;
  let t2;
  if ($[2] !== formatDate || $[3] !== t1) {
    t2 = formatDate(t1);
    $[2] = formatDate;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const releaseDate = t2;
  const t3 = roomData?.last_updated_at;
  let t4;
  if ($[5] !== formatDate || $[6] !== t3) {
    t4 = formatDate(t3);
    $[5] = formatDate;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const lastUpdated = t4;
  if (!releaseDate && !lastUpdated) {
    return null;
  }
  let t5;
  if ($[8] !== releaseDate || $[9] !== t) {
    t5 = releaseDate && <div className="flex w-full items-start gap-4 md:gap-8"><span className="caption text-vive-primary-30 w-[88px] shrink-0">{t("world-info.release-date")}</span><div className="flex flex-1 flex-wrap items-center gap-2"><span className="body-2 text-white">{releaseDate}</span></div></div>;
    $[8] = releaseDate;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== lastUpdated || $[12] !== t) {
    t6 = lastUpdated && <div className="flex w-full items-start gap-4 md:gap-8"><span className="caption text-vive-primary-30 w-[88px] shrink-0">{t("world-info.last-updated")}</span><div className="flex flex-1 flex-wrap items-center gap-2"><span className="body-2 text-white">{lastUpdated}</span></div></div>;
    $[11] = lastUpdated;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default WorldDates;